import { template } from "@ember/template-compiler";
import SlideItem from './slide-item';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import carousel from '../../../modifiers/carousel';
export default class NewsSliderComponent extends Component {
    get articles() {
        return this.args.articles || [];
    }
    get moreThanOne() {
        return false;
    }
    static{
        template(`
    <style>
      .user-avatar.tiny.liquid { overflow: hidden; }
    </style>
    <div id='banner-slider-2' {{carousel}} class='banner-slider v2'>
      <div class='slider-items'>
        {{#each this.articles as |article|}}
          <SlideItem @article={{article}} />
        {{/each}}
      </div>
      {{#if this.moreThanOne}}
        <div class='banner-slider-preview-wrap'>
          <div id='sliderb2-controls' class='banner-slider-controls'>
            <div class='control-previous'>
              <svg class='arrow-icon medium'>
                <use href='#svg-arrow-medium'></use>
              </svg>
            </div>
            <div class='control-next'>
              <svg class='arrow-icon medium'>
                <use href='#svg-arrow-medium'></use>
              </svg>
            </div>
          </div>
          <div id='banner-slider-2-thumbs' class='banner-slider-preview'>
            <div class='banner-slider-preview-roster'>
              <!--
              <div class='post-preview tiny negative no-img gaming-news'><p class='post-preview-title'>The "Clash of
                  Eternity" new game was just released</p>
                <div class='post-author-info-wrap'><p class='post-author-info small light'>By
                    <span class='post-author'>Dexter</span><span class='separator'>|</span>Dec 15th, 2018</p></div>
              </div>
              <div class='post-preview tiny negative no-img game-review'><p class='post-preview-title'>We reviewed the new
                  Magimons game</p>
                <div class='post-author-info-wrap'><p class='post-author-info small light'>By
                    <span class='post-author'>Vellatrix</span><span class='separator'>|</span>Dec 15th, 2018</p></div>
              </div>
              <div class='post-preview tiny negative no-img gaming-news'><p class='post-preview-title'>New expansion pack
                  coming to "Rise of Depredators"</p>
                <div class='post-author-info-wrap'><p class='post-author-info small light'>By
                    <span class='post-author'>Dexter</span><span class='separator'>|</span>Dec 15th, 2018</p></div>
              </div>
              <div class='post-preview tiny negative no-img e-sport'><p class='post-preview-title'>Last night the Wolves
                  beat the Rhinos 12-10</p>
                <div class='post-author-info-wrap'><p class='post-author-info small light'>By
                    <span class='post-author'>Vellatrix</span><span class='separator'>|</span>Dec 15th, 2018</p></div>
              </div>
              -->
            </div>
          </div>
        </div>
      {{/if}}
    </div>
  `, {
            component: this,
            eval () {
                return eval(arguments[0]);
            }
        });
    }
}
